import core from "@/helpers/client";
const vendorService = {
  async headVendorMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors`,
      params
    );
    return result;
  },
  async getVendorMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors`,
      params
    );
    return result;
  },
  async getVendorMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/${id}`
    );
    return result;
  },
  async createVendorMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors`,
      model
    );
    return result;
  },
  async updateVendorMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/${id}`,
      model
    );
    return result;
  },
  async deleteVendorMasterByIdAsync(id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/${id}`
    );
    return result;
  },
  async inviteVendorUserAsync(id,model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/${id}/invites`,
      model
    );
    return result;
  },
  async resentInviteVendorUserAsync(id,user_open_id) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/${id}/invites/${user_open_id}`
    );
    return result;
  },
  async deleteVendorUserByIdAsync(id,user_open_id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/${id}/users/${user_open_id}`
    );
    return result;
  },
};
export default vendorService;
